import { createContext, useContext } from "react";
import type { Resource } from "./useResource";
import type { Status } from "../types";

export type StatusFreshness = "fresh" | "stale" | "unknown";

export interface RuntimeStatusValue extends Resource<Status> {
  freshness: StatusFreshness;
  observedAgeMs: number | null;
  executionReady: boolean;
  recoveryPending?: boolean;
  recoveryGrace?: boolean;
  /** The first seconds of a grace, when the pill keeps what it last showed instead of reconnecting. */
  recoveryQuiet?: boolean;
  active?: boolean;
}

export const RuntimeStatusContext = createContext<RuntimeStatusValue | null>(null);

export function useRuntimeStatus() {
  const value = useContext(RuntimeStatusContext);
  if (!value) throw new Error("useRuntimeStatus must be used inside RuntimeStatusProvider");
  return value;
}
